<template>
  <div class="card p-6 mb-2">
    <h6 class="mb-6 d-flex align-items-center">
      Transfer
      <a href="/#/reisetermine/transferplanung" target="_blank" class="ml-2" title="Transferplanung">
        <Bus :size="16" />
      </a>
    </h6>
    <div class="p-6 mb-2">
      <h6>Hinflug</h6>
      <div class="d-flex" style="gap: 16px">
        <b-form-group label="Transferszenario" class="widthEditField">
          <AppSelect
            v-model="editedSeason.transferszenarioHin"
            sort="none"
            :options="minimaltransferszenarioOptions"
            label="Transferszenario"
            hide-search
            :highlight="changedFields.includes('transferszenarioHin')"
          />
        </b-form-group>

        <b-form-group label="Transfer Kommentar" class="widthEditField">
          <b-form-textarea
            v-model="editedSeason.kommentarTransferszenarioHin"
            :class="{ changed: changedFields.includes('kommentarTransferszenarioHin') }"
            max-rows="3"
            size="sm"
          />
        </b-form-group>

        <b-form-group label="Transfer Besonderheit" class="widthEditField">
          <AppSelect
            v-model="editedSeason.transferHinBesonderheit"
            sort="none"
            :options="transferBesonderheitOptions"
            label="Transfer Besonderheit"
            placeholder="-"
            hide-search
            :highlight="changedFields.includes('transferHinBesonderheit')"
          />
        </b-form-group>

        <b-form-group label="Abweichender Flughafen" class="widthEditField">
          <AirportsSucheMultiselect
            :isChangedMetadata="changedFields.includes('abweichenderFlughafenHinIataCode')"
            v-model="editedSeason.abweichenderFlughafenHinIataCode"
            :isMultipleAllowed="false"
            clearable
            :openDirection="'bottom'"
            :filterCountry="reise?.reisekuerzel.substring(0, 2)"
          ></AirportsSucheMultiselect>
        </b-form-group>
      </div>

      <div class="d-flex" style="gap: 16px">
        <b-form-group label="Max. Wartezeit (Min.)" class="widthEditField">
          <AppSelect
            v-model="editedSeason.hinflugMaxWartezeit"
            :options="maxWartezeitSelectOptions"
            label="Max. Wartezeit"
            placeholder="---"
            hide-search
            :highlight="changedFields.includes('hinflugMaxWartezeit')"
            :disabled="
              editedSeason.transferszenarioHin === 'TX_ohne' ||
              editedSeason.isKeineTransferplanungNotwendigHin
            "
          />
        </b-form-group>

        <b-form-group label="Max. Anzahl an Transfergruppen" class="widthEditField">
          <b-form-input
            :class="{
              changed: changedFields.includes('hinflugMaxAnzahlTransfergruppen'),
              'is-invalid':
                editedSeason.transferszenarioHin === 'T3_unbegr_inkl' &&
                !editedSeason.hinflugMaxAnzahlTransfergruppen &&
                !editedSeason.isKeineTransferplanungNotwendigHin,
            }"
            size="sm"
            v-model="editedSeason.hinflugMaxAnzahlTransfergruppen"
            :number="true"
            type="number"
            min="0"
            max="365"
            step="1"
            required
            :disabled="
              isT4oderTXSelectedInTransferszenarioHin || editedSeason.isKeineTransferplanungNotwendigHin
            "
          ></b-form-input>
          <div
            v-if="
              editedSeason.transferszenarioHin === 'T3_unbegr_inkl' &&
              !editedSeason.hinflugMaxAnzahlTransfergruppen &&
              !editedSeason.isKeineTransferplanungNotwendigHin
            "
            class="invalid-feedback d-block"
          >
            Bei T3 erforderlich für die Transferplanung.
          </div>
        </b-form-group>

        <b-form-group label="Max. Anzahl Gruppen nicht überschreiten" style="width: 270px">
          <b-form-checkbox
            size="lg"
            v-model="editedSeason.maxTransfergruppenBeachtenHin"
            :class="{ changed: changedFields.includes('maxTransfergruppenBeachtenHin') }"
          ></b-form-checkbox>
        </b-form-group>

        <b-form-group label="Keine Transferplanung notwendig" class="widthEditField">
          <b-form-checkbox
            size="lg"
            v-model="editedSeason.isKeineTransferplanungNotwendigHin"
            :class="{ changed: changedFields.includes('isKeineTransferplanungNotwendigHin') }"
          ></b-form-checkbox>
        </b-form-group>
      </div>
    </div>

    <div class="p-6 mb-2">
      <h6>Rückflug</h6>
      <div class="d-flex" style="gap: 16px">
        <b-form-group label="Transferszenario" class="widthEditField">
          <AppSelect
            v-model="editedSeason.transferszenarioRueck"
            sort="none"
            :options="minimaltransferszenarioOptions"
            label="Transferszenario"
            hide-search
            :highlight="changedFields.includes('transferszenarioRueck')"
          />
        </b-form-group>

        <b-form-group label="Transfer Kommentar" class="widthEditField">
          <b-form-textarea
            v-model="editedSeason.kommentarTransferszenarioRueck"
            :class="{ changed: changedFields.includes('kommentarTransferszenarioRueck') }"
            max-rows="3"
            size="sm"
          />
        </b-form-group>

        <b-form-group label="Transfer Besonderheit" class="widthEditField">
          <AppSelect
            v-model="editedSeason.transferRueckBesonderheit"
            sort="none"
            :options="transferBesonderheitOptions"
            label="Transfer Besonderheit"
            placeholder="-"
            hide-search
            :highlight="changedFields.includes('transferRueckBesonderheit')"
          />
        </b-form-group>

        <b-form-group label="Abweichender Flughafen" class="widthEditField">
          <AirportsSucheMultiselect
            :isChangedMetadata="changedFields.includes('abweichenderFlughafenRueckIataCode')"
            v-model="editedSeason.abweichenderFlughafenRueckIataCode"
            :isMultipleAllowed="false"
            clearable
            :openDirection="'bottom'"
            :filterCountry="reise?.reisekuerzel.substring(0, 2)"
          ></AirportsSucheMultiselect>
        </b-form-group>
      </div>
      <div class="d-flex" style="gap: 16px">
        <b-form-group label="Max. Wartezeit (Min.)" class="widthEditField">
          <AppSelect
            v-model="editedSeason.rueckflugMaxWartezeit"
            :options="maxWartezeitSelectOptions"
            label="Max. Wartezeit"
            placeholder="---"
            hide-search
            :highlight="changedFields.includes('rueckflugMaxWartezeit')"
            :disabled="
              editedSeason.transferszenarioRueck === 'TX_ohne' ||
              editedSeason.isKeineTransferplanungNotwendigRueck
            "
          />
        </b-form-group>

        <b-form-group label="Max. Anzahl an Transfergruppen" class="widthEditField">
          <b-form-input
            :class="{
              changed: changedFields.includes('rueckflugMaxAnzahlTransfergruppen'),
              'is-invalid':
                editedSeason.transferszenarioRueck === 'T3_unbegr_inkl' &&
                !editedSeason.rueckflugMaxAnzahlTransfergruppen &&
                !editedSeason.isKeineTransferplanungNotwendigRueck,
            }"
            size="sm"
            v-model="editedSeason.rueckflugMaxAnzahlTransfergruppen"
            :number="true"
            type="number"
            min="0"
            max="365"
            step="1"
            required
            :disabled="
              isT4oderTXSelectedInTransferszenarioRueck || editedSeason.isKeineTransferplanungNotwendigRueck
            "
          ></b-form-input>
          <div
            v-if="
              editedSeason.transferszenarioRueck === 'T3_unbegr_inkl' &&
              !editedSeason.rueckflugMaxAnzahlTransfergruppen &&
              !editedSeason.isKeineTransferplanungNotwendigRueck
            "
            class="invalid-feedback d-block"
          >
            Bei T3 erforderlich für die Transferplanung.
          </div>
        </b-form-group>

        <b-form-group label="Max. Anzahl Gruppen nicht überschreiten" style="width: 270px">
          <b-form-checkbox
            size="lg"
            v-model="editedSeason.maxTransfergruppenBeachtenRueck"
            :class="{ changed: changedFields.includes('maxTransfergruppenBeachtenRueck') }"
          ></b-form-checkbox>
        </b-form-group>

        <b-form-group label="Keine Transferplanung notwendig" class="widthEditField">
          <b-form-checkbox
            size="lg"
            v-model="editedSeason.isKeineTransferplanungNotwendigRueck"
            :class="{ changed: changedFields.includes('isKeineTransferplanungNotwendigRueck') }"
          ></b-form-checkbox>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import AirportsSucheMultiselect from '@/components/common/airports-suche-multiselect.vue';
import { maxWartezeitOptions, minimaltransferszenarioOptions } from '@/core/common/helpers/utils.js';
import AppSelect from '@/components/common/app-select/app-select.vue';
import { Bus } from 'lucide-vue';

export default {
  name: 'ReisenMetadataCardTransfer',
  components: {
    AirportsSucheMultiselect,
    AppSelect,
    Bus,
  },
  props: {
    editedSeason: { type: Object, required: true },
    changedFields: { type: Array, default: () => [] },
    reise: { type: Object, default: null },
  },
  data() {
    return {
      maxWartezeitOptions,
      minimaltransferszenarioOptions,
      transferBesonderheitOptions: [
        { value: null, text: '-' },
        { value: 'Shuttle', text: 'Shuttle' },
        { value: 'AbfahrtzeitDurchCm', text: 'Abfahrtzeit durch CM' },
        { value: 'WartezeitVornacht', text: 'Wartezeit Vornacht' },
      ],
    };
  },
  computed: {
    // Die Wartezeiten sind Zahlen, als Optionstext werden sie in Strings gewandelt
    maxWartezeitSelectOptions() {
      return this.maxWartezeitOptions.map(wartezeit => ({ value: wartezeit, text: String(wartezeit) }));
    },
    // Bei den Szenarien T4 und TX ist die Anzahl der Transfergruppen nicht begrenzbar, deshalb wird das Feld dann gesperrt
    isT4oderTXSelectedInTransferszenarioHin() {
      return (
        this.editedSeason.transferszenarioHin === 'T4_unbegr_exkl' ||
        this.editedSeason.transferszenarioHin === 'TX_ohne'
      );
    },
    isT4oderTXSelectedInTransferszenarioRueck() {
      return (
        this.editedSeason.transferszenarioRueck === 'T4_unbegr_exkl' ||
        this.editedSeason.transferszenarioRueck === 'TX_ohne'
      );
    },
  },
  // Die Watcher setzen abhängige Felder automatisch zurück, sobald eine Auswahl bestimmte Felder überflüssig oder ungültig macht
  watch: {
    // Besonderheit "Shuttle" bedeutet, dass keine Transferplanung notwendig ist
    'editedSeason.transferHinBesonderheit': {
      handler(newValue) {
        if (newValue === 'Shuttle') {
          this.editedSeason.isKeineTransferplanungNotwendigHin = true;
        }
      },
    },
    'editedSeason.transferRueckBesonderheit': {
      handler(newValue) {
        if (newValue === 'Shuttle') {
          this.editedSeason.isKeineTransferplanungNotwendigRueck = true;
        }
      },
    },
    // T4/TX kennen keine begrenzte Gruppenanzahl; TX_ohne bedeutet zusätzlich keine Wartezeit und keine Transferplanung
    'editedSeason.transferszenarioHin': {
      handler(newValue) {
        if (newValue === 'T4_unbegr_exkl' || newValue === 'TX_ohne') {
          this.editedSeason.hinflugMaxAnzahlTransfergruppen = null;
        }
        if (newValue === 'TX_ohne') {
          this.editedSeason.hinflugMaxWartezeit = null;
          this.editedSeason.isKeineTransferplanungNotwendigHin = true;
        }
      },
    },
    'editedSeason.transferszenarioRueck': {
      handler(newValue) {
        if (newValue === 'T4_unbegr_exkl' || newValue === 'TX_ohne') {
          this.editedSeason.rueckflugMaxAnzahlTransfergruppen = null;
        }
        if (newValue === 'TX_ohne') {
          this.editedSeason.rueckflugMaxWartezeit = null;
          this.editedSeason.isKeineTransferplanungNotwendigRueck = true;
        }
      },
    },
    // Ist keine Transferplanung notwendig, werden Wartezeit und Gruppenanzahl geleert
    'editedSeason.isKeineTransferplanungNotwendigHin': {
      handler(newValue) {
        if (newValue) {
          this.editedSeason.hinflugMaxWartezeit = null;
          this.editedSeason.hinflugMaxAnzahlTransfergruppen = null;
        }
      },
    },
    'editedSeason.isKeineTransferplanungNotwendigRueck': {
      handler(newValue) {
        if (newValue) {
          this.editedSeason.rueckflugMaxWartezeit = null;
          this.editedSeason.rueckflugMaxAnzahlTransfergruppen = null;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.widthEditField {
  width: 225px;
}

:deep(.changed) {
  background-color: #3699ff50;
}

:deep(input:disabled) {
  background-color: var(--surface-sunken) !important;
}
</style>
